import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import ReactInk from 'react-ink';
import { toggleBodyFixed } from '../helpers';

import './Style';

class MenuPortal extends Component {
    constructor() {
        super();

        this.mobileMenuWrapperClick = this.mobileMenuWrapperClick.bind(this);
        this.windowKeyDown = this.windowKeyDown.bind(this);
    }

    componentDidMount () {
        window.addEventListener('keydown', this.windowKeyDown, false);
        window.addEventListener('click', this.mobileMenuWrapperClick, false);
        window.addEventListener('touchstart', this.mobileMenuWrapperClick, false);
        toggleBodyFixed();
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.windowKeyDown, false);
        window.removeEventListener('click', this.mobileMenuWrapperClick, false);
        window.removeEventListener('touchstart', this.mobileMenuWrapperClick, false);
        toggleBodyFixed(false);
    }

    windowKeyDown(e) {
        if (e.code.toLowerCase() === 'escape' && this.props.isOpened) {
            this.props.btnClick(false);
        }
    }

    mobileMenuWrapperClick(e) {
        if (e.target.classList.contains('portal-menu')) {
            this.props.btnClick(false);
        }
    }

    render () {

        const { btnClick, isOpened } = this.props;

        const menuClass = isOpened ? 'portal-menu open' : 'portal-menu';

        return ReactDOM.createPortal(
            <div className={menuClass} onClick={this.portalMenuWrapperClick}>
                <div className="portal-menu-body">
                    <div className="portal-menu-header">
                        <span>menu</span>
                        <button className="btn btn-transparent" onClick={() => {btnClick(false)}}>
                        <ReactInk />
                            <i className="close-icon"></i>
                        </button>
                    </div>
                    {this.props.children}
                </div>
            </div>,
            document.getElementById('portals')
        )
    }
}

const mapStateToProps = (state) => {
    return {
        prop: state.prop
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuPortal)
